import React, { FC } from 'react';

import { PlayerApiError } from '@/scenarios/legacy-player/types/error';

import { PlayerView } from '../../player-view/component';
import { PlayerTracker } from '../../player-tracker/component';
import { TrailerPlayerController } from '../trailer-player-controller/component';
import { TrailerPlayerTracker } from '../trailer-player-tracker/component';
import { TrailerPlayerSkin } from '../trailer-player-skin/component';

import styles from './styles.module.css';

interface Props {
    contentId: string;
    psid: string;
    onContentImpression: () => void;
    onFinish?: () => void;
    onError?: (error: PlayerApiError) => void;
    onClose?: () => void;
}

export const TrailerPlayer: FC<Props> = ({
    contentId,
    psid,
    onError,
    onContentImpression,
    onFinish,
    onClose,
}) => (
    <PlayerTracker>
        <TrailerPlayerController
            onContentImpression={onContentImpression}
            onFinish={onFinish}
            onError={onError}
        />
        <TrailerPlayerTracker contentId={contentId} psid={psid} />
        <PlayerView className={styles.root}>
            <TrailerPlayerSkin contentId={contentId} className={styles.skin} onClose={onClose} />
        </PlayerView>
    </PlayerTracker>
);
